import { type PropsWithChildren } from "react";

import { type TableSelection } from "@devexpress/dx-react-grid-bootstrap4";
import { useLandingPageAnalyticsContext } from "@features/landing-page-analytics/hooks";
import { CustomCheckbox } from "@shared/custom-checkbox";

export const TableSelectionCell = ({
  selected,
  row,
  onToggle,
  tableRow,
  tableColumn,
  ...restOfProps
}: PropsWithChildren<TableSelection.CellProps>) => {
  const {
    tableState: { selectedRows },
  } = useLandingPageAnalyticsContext();

  const isDisabled = !selected && selectedRows.length > 9;

  return (
    <td className="sticky left-0 " {...restOfProps}>
      <div
        className="flex items-center justify-center w-full h-full"
        onClick={() => {
          if (!isDisabled) {
            onToggle();
          }
        }}
      >
        <CustomCheckbox
          className="pointer-events-none"
          disabled={isDisabled}
          checked={selected}
        />
      </div>
    </td>
  );
};
